export default __webpack_public_path__ + "static/media/confi.e6753843.jpg";